import { useMutation } from '@tanstack/react-query';
import { getQueryClientInstance } from '@/api/queries/queryClient';
import { UserProfileBase } from '@/models';
import { UserApiService } from '@/api/userProfile/UserApiService';
import { userProfileCacheKeys } from '@/api/queries/userProfile/cacheKeys';

const queryClient = getQueryClientInstance();

export const useCreateUserProfile = () => {
  return useMutation({
    mutationFn: (userData: Partial<UserProfileBase>) => UserApiService.createUser(userData),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: userProfileCacheKeys.fetch });
    },
  });
};
